module.exports = __webpack_public_path__ + "img/picture.d7cb111.webp";